<template>     
    <section class="content">
        <div class="container-fluid p-0 p-md-2">
            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-header">
                            <h3 class="card-title">Listado de tipos de abonos</h3>
                            <div class="card-tools mt-3 text-center">
                                <Button v-if="listas && listas.length > 0" @click="showModal('cargarPrecios')" class="mb-1 mb-md-0">Cargar precios de una temporada anterior</Button>
                                <CargarPrecios v-if="listas && listas.length > 0" :listas="listas" v-on:close="closeModal" @preciosCargados="getTipos()"></CargarPrecios>
                                <router-link :to="{ name: 'back.abonos.precios.grupos' }" class="btn btn-primary ml-3 mr-3 pt-2 mb-1 mb-md-0">Agrupar precios</router-link>
                                <router-link :to="{ name: 'back.frecuencias' }" class="btn btn-primary mr-3 pt-2 mb-1 mb-md-0" target="blank">Frecuencias pago a plazos</router-link>
                                <Button @click="showModal('crearPrecio')">Crear nuevo tipo de abono</Button>
                                <CreatePrecioModal :lista_id="$store.getters.getListaId" v-on:close="closeModal"></CreatePrecioModal>
                            </div>
                        </div>

                        <div class="card-header">
                            <div class="row justify-content-between">
                                <div class="col-12">
                                    <div class="input-group input-group-sm">
                                        <input type="text" name="table_search" class="form-control" placeholder="Buscar" v-model="filters.search">

                                        <div class="input-group-append">
                                            <Button type="submit" variant="default" icon="fas fa-search" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table table-hover">
                                    <thead>
                                        <tr>
                                            <th>Descripción</th>
                                            <th>Stock</th>
                                            <th class="text-center">Activo</th>
                                            <th class="text-center">Renovación</th>
                                            <th class="text-center">Pago a plazos</th>
                                            <th class="text-center">Opciones</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="!loading">
                                        <template v-for="(tipo, index) in tipos.data">
                                            <tr :key="index">
                                                <td>{{ tipo.descripcion }}</td>
                                                <td>
                                                    <ul>
                                                        <li>
                                                            <small>Stock: {{tipo.stock}}</small>
                                                        </li>
                                                        <li>
                                                            <small>En sesión: {{tipo.stock_sesion}}</small>
                                                        </li>
                                                        <li>
                                                            <small>Total: {{tipo.stock_calculado}}</small>
                                                        </li>
                                                    </ul>
                                                </td>
                                                <td class="text-center">
                                                    <CheckOrCross :condition="tipo.activo"/>
                                                </td>
                                                <td class="text-center">
                                                    <CheckOrCross :condition="tipo.renovacion"/>
                                                </td>
                                                <td class="text-center">
                                                    <CheckOrCross :condition="tipo.activar_pago_plazos"/>
                                                </td>
                                                <td class="text-center">
                                                    <OpcionesDropdownComponent v-bind:options="[
                                                        { to: { name: 'back.abonos.precios.descuentos', params: { precio_id: tipo.id}}, label: 'VER PRECIOS'},
                                                        { type: 'action', action:() => showModal('editarPrecio-' + tipo.id), label: 'EDITAR'},
                                                        { type: 'action', action:() => showModal('borrar-' + tipo.id), label: 'BORRAR'},
                                                    ]" v-on:open="onOpenOptions" v-on:close="onCloseOptions"/>
                                                </td>
                                            </tr>
                                            <EditPrecioModal :key="index + '-'" :precio="tipo" :lista_id="$store.getters.getListaId" v-on:close="closeModal"></EditPrecioModal>
                                            <DeletePrecioModal :key="index + '--'" :precio="tipo" :lista_id="$store.getters.getListaId" v-on:close="closeModal"></DeletePrecioModal>
                                        </template>
                                    </tbody>
                                    <tbody v-else>
                                        <tr>
                                            <td colspan="3">
                                                <LoaderComponent></LoaderComponent>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <hr>
                            <div class="row justify-content-between" v-if="!loading">
                                <div class="col-md-6 col-sm-12">
                                    <ElementosPorPaginaComponent
                                        :value="filters.per_page"
                                        @input="changePerPage"
                                    />
                                </div>
                                <div class="col-md-6 col-sm-12" v-if="tipos">
                                    <PaginateComponent :current_page="tipos.meta.current_page" :last_page="tipos.meta.last_page" v-on:change_page="setPage"></PaginateComponent>
                                </div>
                            </div>
                        </div>
                    </div>
                    <MainContentTabs
                        :tabs="[
                            recinto && recinto.url_svg_asientos ? { tab: 'configurar-precios-desde-plano', nombre: 'Configurar precios desde el plano' } : null,
                            { tab: 'configurar-precios', nombre: 'Configurar precios' },
                            { tab: 'configurar-precios-regiones-anexas', nombre: 'Configurar precios regiones anexas' }
                        ].filter(tab => tab !== null)"
                        :initialTab="recinto && recinto.url_svg_asientos ? 'configurar-precios-desde-plano' : 'configurar-precios'"
                    >

                        <template slot="configurar-precios-desde-plano">
                            <TabPreciosDesdePlano :recinto="recinto" :tipos="tipos"/>
                        </template>
                        <template slot="configurar-precios">                            
                            <div class="card">
                                <div class="card-header">
                                    <h3 class="card-title">Configurar precios</h3>
                                </div>
                                
                                <div class="card-body">
                                    <PreciosZonasComponent v-if="tipos" :tipos="tipos" :place_id="recinto.id" :esMovil="esMovil"></PreciosZonasComponent>
                                </div>
                            </div>
                        </template>
                        <template slot="configurar-precios-regiones-anexas">                            
                            <div class="d-block d-md-flex align-items-center justify-content-between text-center">
                                <h5 class="m-0">Configurar precios de las regiones</h5>
                                <button
                                    class="btn btn-primary mt-2 mt-md-0"
                                    v-if="isZonaSeleccionada"
                                    @click="unSelectZona"
                                >
                                    Seleccionar otra región
                                </button>
                            </div>
                            
                            <div class="p-0 pt-3 pt-md-3">
                                <PreciosRegionesAnexasComponent
                                    v-if="tipos"
                                    :tipos="tipos"
                                    :place_id="recinto.id"
                                    :esMovil="esMovil"
                                    :unSelectZonaItem="unSelectZonaItem"
                                    @zonaIsSelected="isZonaSeleccionada = true"
                                />
                            </div>
                        </template>
                    </MainContentTabs>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import LoaderComponent from '@/components/preloader/LoaderComponent';
import PaginateComponent from '@/components/table/pagination/BackPaginateComponent';
import CreatePrecioModal from '../modals/CreatePrecioModal';
import DeletePrecioModal from '../modals/DeletePrecioModal';
import PreciosZonasComponent from '@/components/backend/abonos/precios/PreciosZonasComponent';
import OpcionesDropdownComponent from '@/components/backend/components/OpcionesDropdownComponent';
import CheckOrCross from "@/components/backend/components/CheckOrCross";
import EditPrecioModal from '../modals/EditPrecioModal.vue';
import ElementosPorPaginaComponent from '@/components/backend/components/ElementosPorPaginaComponent.vue';
import CargarPrecios from '../modals/CargarPrecios';
import MainContentTabs from '@/components/backend/components/MainContentTabs.vue';
import TabPreciosDesdePlano from './TabPreciosDesdePlano';
import PreciosRegionesAnexasComponent from '@/components/backend/abonos/precios/PreciosRegionesAnexasComponent.vue';

export default {
    data() {
        return {
            loading: true,
            filters: {
                per_page: 10,
                page: 1,
                search: '',
                all: 1
            },
            expand: [],
            tipos: null,
            zonas: [],
            openOptions: [],
            isZonaSeleccionada: false,
            unSelectZonaItem: 1,
            esMovil: false
        }
    },
    created() {
        this.getTipos();
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        },
        manager() {
            return this.$store.getters.getFooter;
        },
        listas() {
            return this.$store.getters.getListas.filter(lista => lista.activa == 0);
        },
        recinto() {
            return this.$store.getters.getRecinto;
        }
    },
    methods: {
        getTipos : function() {
            this.loading = true;
            const params = {
                filters : this.filters,
                lista_id: this.$store.getters.getListaId
            };

            this.$store.dispatch(this.config.getVuexAlias('back.precios.index'), params).then(res => {
                this.tipos = res.data;
                this.loading = false;
            });
        },
        setPage(page) {
            this.filters.page = page;
            this.getTipos();
        },
        showModal(modal) {
            this.$modal.show(modal);
        },
        closeModal(modal, creado) {
            this.expand = [];

            this.openOptions.forEach(opt => opt.close());
            this.openOptions = [];

            if(creado) {
                this.getTipos();
            }

            this.$modal.hide(modal);
        },
        onOpenOptions(ref) {
            this.openOptions.push(ref);
        },
        onCloseOptions(ref) {
            this.openOptions.split(this.openOptions.indexOf(ref), 1);
        },
        changePerPage(per_page) {
            this.filters.per_page = per_page;
            this.getTipos();
        },
        unSelectZona() {
            this.unSelectZonaItem++;
            this.isZonaSeleccionada = false;
        },
        onResize() {
            this.esMovil = window.innerWidth < 768;
        }
    },
    beforeDestroy() {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.onResize, { passive: true })
        }
    },
    mounted() {
        this.onResize()
        window.addEventListener('resize', this.onResize, { passive: true })
    },
    components: {
        CheckOrCross, LoaderComponent, PaginateComponent, CreatePrecioModal,
        EditPrecioModal, DeletePrecioModal, PreciosZonasComponent, OpcionesDropdownComponent,
        ElementosPorPaginaComponent, CargarPrecios, MainContentTabs, TabPreciosDesdePlano, PreciosRegionesAnexasComponent
    }
}
</script>

<style>
    .multiselect__tag {
        font-size: 9px;
    }
    .multiselect__tag-icon {
        line-height: 17px;
    }
</style>
